import { render, staticRenderFns } from "./ManualPayrunNoteWizard.vue?vue&type=template&id=b44e20c0&"
import script from "./ManualPayrunNoteWizard.vue?vue&type=script&lang=js&"
export * from "./ManualPayrunNoteWizard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports